import axios from './_nestAxios'

export const convertirTablaAExcel = data => axios.post('/util/convertir/tabla-a-excel', data, { responseType: 'blob' })
